import {connect} from "redux-vue";
import classNames from "classnames";
import Notifications from "./Notifications";
import * as userActions from "../actions/user";
import {getScreenSize} from "../helpers/screens";
import {getPhotoSrc} from "../helpers/tools";

const Nav = {
  /**
   *
   */
  props: ['sticky', 'user', 'logout', 'notifications', 'fixed'],

  /**
   *
   * @returns {{menuLang: boolean, menuAccount: boolean, menuNotification: boolean, menuApps: boolean}}
   */
  data() {
    return {
      menuLang: false,
      menuApps: false,
      windowTop: true,
      menuAccount: false,
      menuNotification: false,
    }
  },

  /**
   *
   */
  methods: {
    openNotification() {
      this.closeAll();
      setTimeout(() => {
        this.menuNotification = true;
      }, 120);
    },

    openAccount() {
      if(this.menuNotification) {
        setTimeout(() => this.menuAccount = true, 120);
        this.closeAll();
      } else {
        this.closeAll();
        this.menuAccount = true;
      }
    },

    toggleLang() {
      this.toggleMenu("menuLang");
    },

    toggleApps() {
      this.toggleMenu("menuApps");
    },

    toggleMenu(name) {
      const cache = this[name];
      this.closeAll();
      this[name] = !cache;
    },

    closeAll() {
      this.menuLang = false;
      this.menuApps = false;
      this.menuAccount = false;
      this.menuNotification = false;
    },

    updateScroll() {
      this.windowTop = (window.scrollY <= 0);
    },

    onBrandLoaded() {
      document.documentElement.style
        .setProperty("--js-navbar-height", this.$refs.navRef.clientHeight + "px");
    },

    handleClickAway(e) {
      const element = this.$refs.navRef;

      if (e.target !== element && !element.contains(e.target)) {
        this.closeAll();
      }
    }
  },

  /**
   *
   */
  computed: {
    isMenuAccount() {
      return this.menuAccount === true;
    },

    isMenuNotification() {
      return this.menuNotification === true;
    },

    isMenuAccountNotification() {
      return this.isMenuAccount || this.isMenuNotification;
    },

    isMenu() {
      return this.isMenuAccountNotification || this.menuLang || this.menuApps;
    },

    bgTransparent() {
      return this.windowTop && this.$route.name === 'HomePage' && ['lg', 'xl'].includes( getScreenSize() );
    }
  },

  /**
   *
   */
  mounted() {
    document.addEventListener("click", this.handleClickAway);

    if (this.$route.name === "HomePage") {
      window.addEventListener('scroll', this.updateScroll);
    } else {
      window.removeEventListener('scroll', this.updateScroll)
    }

    this.onBrandLoaded();
  },

  /**
   *
   */
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickAway);
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const isAuthorized = !!(this.user.token && this.user.model);
    const navClass = classNames(
      "z-50 top-0",
      { "sticky": this.sticky },
      this.fixed ? "fixed w-screen" : "relative",
      // { "sticky": this.sticky || (!this.sticky && this.isMenu)}
    );

    return (
      <nav ref="navRef" class={navClass}>
        <div class="flex flex-col lg:flex-row absolute h-full w-full z-0">
          {isAuthorized && (
            <fragment>
              <div class={classNames("w-full h-16 lg:h-full lg:w-8/12", {"bg-teal-800" : !this.bgTransparent})}></div>
              <div class={classNames("w-full h-10 lg:h-full lg:w-4/12", {"bg-teal-900" : !this.bgTransparent})}></div>
            </fragment>
          )}
          {isAuthorized || (
            <fragment>
              <div class={classNames("w-full h-16 lg:h-full lg:w-6/12 xl:w-7/12", {"bg-teal-800" : !this.bgTransparent})}></div>
              <div class={classNames("w-full h-10 lg:h-full lg:w-6/12 xl:w-5/12", {"bg-teal-900" : !this.bgTransparent})}></div>
            </fragment>
          )}
        </div>

        <div class="z-10 relative">
          <div class="container lg:px-6 mx-auto">
            <ul class="flex flex-wrap justify-around lg:justify-start h-full z-10 relative text-white text-sm lg:text-base">
              <li class="flex mx-auto lg:mx-0 lg:mr-20 w-full lg:w-auto">
                <router-link to={{name: 'HomePage'}} class="flex items-center py-2 lg:py-4 mx-auto lg:mx-0">
                  <img onLoad={this.onBrandLoaded} src="/img/Learn_Horiz_Neg_Color.svg" alt="Immunization Academy's IA Learn" class="w-32 lg:w-40"/>
                </router-link>
              </li>
              
              <li class="hidden lg:block ml-auto p-6"></li>
              {/* <li class={classNames("lg:relative lg:mr-2", {"lg:bg-teal-900" : !this.bgTransparent})}>
                <button onClick={this.toggleLang} type="button" class={classNames("focus:outline-none h-full lg:py-2", this.menuLang ? 'text-yellow-500 z-10 relative' : 'hover:text-teal-100')}>
                  En
                  <i class="mdi mdi-chevron-down text-sm lg:text-base ml-1"></i>
                </button>
                {this.menuLang && <div onClick={this.toggleLang} class="lg:hidden fixed top-0 bottom-0 left-0 right-0 bg-black opacity-50"></div>}
                <transition
                  name="custom-classes-transition"
                  enter-active-class="transition ease-out duration-100 transform"
                  enter-class="opacity-0 scale-95"
                  enter-to-class="opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75 transform"
                  leave-class="opacity-100 scale-100"
                  leave-to-class="opacity-0 scale-95"
                >
                  {this.menuLang && (
                    <div class="origin-top lg:origin-top-left absolute left-0 w-screen lg:w-56 lg:rounded-b-md shadow-lg">
                      <ul class="bg-white lg:rounded-b-md shadow-xs text-gray-800">
                        <li class="lg:hidden px-4 flex items-center justify-between border-b border-gray-400 shadow-md">
                          <div class="font-bold text-sm">
                            {this.$t('nav.select_language')}
                          </div>
                          <button onClick={this.toggleLang} type="button" class="focus:outline-none">
                            <i class="mdi mdi-close text-3xl"></i>
                          </button>
                        </li>
                        <li class="px-4 py-3 border-b border-gray-400 flex items-center lg:justify-between">
                          English
                          <i class="mdi mdi-check-circle text-green-500 text-xl leading-none ml-3 lg:ml-0"></i>
                        </li>
                        <li class="px-4 py-3 border-b border-gray-400">
                          Français (coming soon!)
                        </li>
                        <li class="px-4 py-3">
                          Kiswahili (coming soon!)
                        </li>
                      </ul>
                    </div>
                  )}
                </transition>
              </li> */}
	      <li class="flex items-center lg:mr-5">
                <router-link to={{name: 'HelpPage'}} class="rounded-full h-5 w-5 flex items-center justify-center bg-white">
                <i class="mdi mdi-help text-black"></i>
                </router-link>
              </li>
              <li class="lg:relative lg:mr-8">
                <button onClick={this.toggleApps} type="button" class={classNames("focus:outline-none h-full lg:py-2 lg:pr-5 lg:pl-10", this.menuApps ? 'text-yellow-500 z-10 relative' : 'hover:text-teal-100')}>
                  <i class="mdi mdi-apps text-xl lg:text-2xl"></i>
                </button>
                {this.menuApps && <div onClick={this.toggleApps} class="lg:hidden fixed top-0 bottom-0 left-0 right-0 bg-black opacity-50"></div>}
                <transition
                  name="custom-classes-transition"
                  enter-active-class="transition ease-out duration-100 transform"
                  enter-class="opacity-0 scale-95"
                  enter-to-class="opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75 transform"
                  leave-class="opacity-100 scale-100"
                  leave-to-class="opacity-0 scale-95"
                >
                  {this.menuApps && (
                    <div class="origin-top lg:origin-top-right absolute right-0 w-screen lg:max-w-2xl lg:rounded-b-md shadow-lg">
                      <ul class="bg-white lg:rounded-b-md shadow-xs text-gray-900">
                        <li class="lg:bg-gray-200 px-5 py-1 lg:py-5 flex items-center justify-between border-b border-gray-400 lg:border-none shadow-md lg:shadow-none">
                          <div class="font-bold whitespace-no-wrap">
                            More From Immunization Academy
                          </div>
                          <button onClick={this.toggleApps} type="button" class="focus:outline-none lg:hidden">
                            <i class="mdi mdi-close text-3xl"></i>
                          </button>
                        </li>
                        <li class="flex flex-col lg:flex-row">
                          <div class="lg:w-1/2 p-5 py-1 lg:py-3 border-b lg:border-b-0 lg:border-r">
                            <div class="flex items-center pb-3 relative">
                              <a href="//watch.immunizationacademy.com" target="_blank" class="absolute top-0 left-0 w-full h-full"></a>
                              <div>
                                <img src="/img/menulinks_watch.svg" alt="IA Watch" class="h-8 my-4"/>
                                <p class="text-xs pr-4">
                                An online learning website with 100+ short videos for immunization professionals.
                                </p>
                              </div>
                              <i class="mdi mdi-chevron-right text-2xl"></i>
                            </div>
                          </div>
                          <div class="lg:w-1/2 p-5 py-1 lg:py-3">
                            <div class="flex items-center pb-3 relative">
                              <a href="//score.immunizationacademy.com" target="_blank" class="absolute top-0 left-0 w-full h-full"></a>
                              <div>
                                <img src="/img/appmenu_score.svg" alt="IA Score" class="h-8 my-4"/>
                                <p class="text-xs pr-4">
                                  Take short online assessments to identify immunization skill and knowledge gaps -- and receive individualized learning plans.
                                </p>
                              </div>
                              <i class="mdi mdi-chevron-right text-2xl"></i>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </transition>
              </li>
              {isAuthorized && (
                <li>
                  <button onClick={this.openAccount} type="button"
                          class={classNames("focus:outline-none h-full", this.isMenuAccountNotification ? 'text-yellow-500 z-10 relative' : 'hover:text-teal-100')}>
                    <div class="flex items-center relative">
                      <transition
                        name="custom-classes-transition"
                        enter-active-class="transition ease-out duration-100 transform"
                        enter-class="opacity-0 scale-95"
                        enter-to-class="opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75 transform"
                        leave-class="opacity-100 scale-100"
                        leave-to-class="opacity-0 scale-95"
                      >
                        {this.notifications.collection.length > 0 && (
                          <div class="origin-bottom lg:origin-bottom-left lg:mb-1 nav-tooltip">
                            {this.notifications.collection.length}
                          </div>
                        )}
                      </transition>
                      <i class="mdi mdi-account-circle text-xl lg:text-3xl"></i>
                      {isAuthorized && this.user.model.avatar && (
		                    <div style={`background-image: url(${getPhotoSrc(this.user.model.avatar)})`} alt="" class="absolute transform scale-125 translate-x-px lg:translate-x-1 h-4 lg:h-6 w-4 lg:w-6 rounded-full bg-cover"/>
                      )}
                      <i class="mdi mdi-chevron-down text-sm lg:text-base"></i>
                    </div>
                  </button>
                  {this.isMenuAccountNotification && <div onClick={this.closeAll} class="lg:hidden fixed top-0 bottom-0 left-0 right-0 bg-black opacity-50"></div>}
                  <transition
                    name="custom-classes-transition"
                    enter-active-class="transition ease-out duration-100 transform"
                    enter-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75 transform"
                    leave-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                  >
                    {this.menuAccount && (
                      <div
                        class="origin-top lg:origin-top-right absolute right-0 w-screen lg:w-2/6 xl:w-1/4 lg:rounded-b-md shadow-lg">
                        <div class="bg-white lg:rounded-b-md shadow-xs text-lg text-gray-900 h-screen lg:h-auto">
                          <button onClick={this.closeAll} type="button" class="p-3 focus:outline-none float-right lg:hidden">
                            <i class="mdi mdi-close text-3xl leading-none"></i>
                          </button>
                          <ul class="text-base py-5 leading-loose">
                            <li class="mb-5">
                              <router-link to={{name: 'CoursesPage'}} class="block px-10 flex items-center">
                                <i class="mdi mdi-school text-yellow-500 mr-1 text-xl leading-none"></i>
                                {this.$t('nav.my_courses')}
                              </router-link>
                            </li>
                            <li class="mb-5">
                              <router-link to={{name: 'ProfilePage'}} class="block px-10 flex items-center">
                                <i class="mdi mdi-account-circle text-yellow-500 mr-1 text-xl leading-none"></i>
                                {this.$t('nav.my_profile')}
                              </router-link>
                            </li>
                            {/* <li class="mb-5 border-t border-b">
                            <span onClick={this.openNotification} class="cursor-pointer block py-2 px-10 flex items-center">
                              <i class="mdi mdi-bell text-yellow-500 mr-1 text-xl"></i>
                              {this.$t('nav.notifications')}
                              {this.notifications.collection.length > 0 && (
                                <span class="h-6 w-6 bg-teal-500 text-white rounded-full text-xs mx-2 text-center">
                                  {this.notifications.collection.length}
                                </span>
                              )}
                              <i class="mdi mdi-chevron-right ml-auto text-2xl"></i>
                            </span>
                            </li> */}
			    {/* <li class="mb-5">
                              <a href="https://immunizationacademy.com" target="_blank" class="block px-10 flex items-center">
                                <i class="mdi mdi-monitor-dashboard text-teal-600 mr-1 text-xl leading-none"></i>
                                Immunization Academy
                              </a>
                            </li>
			    <li class="mb-5 pl-5">
                              <a href="https://immunizationacademy.com/profile#achievements" target="_blank" class="block px-10 flex items-center">
                                <i class="mdi mdi-certificate text-teal-600 mr-1 text-xl leading-none"></i>
                                My Achievements
                              </a>
                            </li>
			    <li class="mb-5 pl-5">
                              <a href="https://immunizationacademy.com/profile" target="_blank" class="block px-10 flex items-center">
                                <i class="mdi mdi-account-circle text-teal-600 mr-1 text-xl leading-none"></i>
                                My Profile
                              </a>
                            </li>
			    <li class="mb-5 border-b pl-5">
                              <a href="https://immunizationacademy.com/memberdirectory" target="_blank" class="block pb-5 px-10 flex items-center">
                                <i class="mdi mdi-account-search text-teal-600 mr-1 text-xl leading-none"></i>
                                Member Directory
                              </a>
                            </li> */}
                            <li>
                              <span onClick={this.logout} class="block cursor-pointer px-10 flex items-center">
                                <i class="mdi mdi-logout-variant text-gray-400 mr-1 text-xl"></i>
                                {this.$t('sign_out')}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                    {this.menuNotification && (
                      <div class="origin-top lg:origin-top-right absolute right-0 w-screen lg:w-2/5 lg:rounded-b-md shadow-lg">
                        <Notifications handleMenuDismiss={this.openAccount} />
                      </div>
                    )}
                  </transition>
                </li>
              )}
              {isAuthorized || (
                <fragment>
                  <li class="items-center hidden lg:flex">
                    <router-link to={{name: 'RegisterModal'}} class="text-yellow-500">
                      Create an Account
                    </router-link>
                  </li>
                  <li class="hidden lg:flex items-center px-2">|</li>
                  <li class="flex items-center">
                    <router-link to={{name: 'LoginModal'}} class="text-yellow-500">
                      Sign In
                    </router-link>
                  </li>
                </fragment>
              )}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    notifications: state.notifications,
  };
}

function mapActionToProps(dispatch) {
  return {
    logout: () => dispatch(userActions.logout()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(Nav);
